<template>
  <div class="wrapper">
    <vue-confirm-dialog></vue-confirm-dialog>
    <div class="upload">
      <Header />
      <h2 class="page_title">企画書登録画面</h2>
      <div class="form">
        <dl class="form_list">
          <dt>登録日</dt>
          <dd><input type="date" id="entdt" v-model="values.entdt" :class="{'error':errors.entdt}" class="w_m error_frame text-type03">
            <span class="error__text" v-show="errors.entdt">未入力です</span>
          </dd>
          <dt>案件名</dt>
          <dd>
            <input type="text" id="name" v-model="values.name" placeholder="例）おかやまプロモーション（最大30文字）" :class="{'error':errors.name}" class="text-type03">
            <span class="error__text" v-show="errors.name">未入力です</span>
          </dd>
          <dt>顧客名</dt>
          <dd>
            <input type="text" id="client_name" v-model="values.client_name" placeholder="例）企業・自治体名＋部課名（最大30文字）" :class="{'error':errors.client_name}" class="text-type03">
            <span class="error__text" v-show="errors.client_name">未入力です</span>
          </dd>
          <dt>関係者タグ</dt>
          <dd class="form_check">
            <ul class="form_check-list">
              <template v-for="list in values.pe_m_tag_pk">
                <li v-if="list.checked" :key="list.value">{{list.text}}</li>
              </template>
            </ul>
            <p class="form_check-btn"><button type="button" class="btn01 cl_wh" v-on:click="showModalU('check_tag01')"><svg>
                <use xlink:href="/svg/sprite.svg#icon_pen" /></svg></button></p>
          </dd>
          <dt>事業タグ</dt>
          <dd class="form_check">
            <ul class="form_check-tag">
              <template v-for="list in values.b_m_tag_pk">
                <li v-if="list.checked" :key="list.value">{{list.text}}</li>
              </template>
            </ul>
            <p class="form_check-btn"><button type="button" class="btn01 cl_wh" v-on:click="showModalU('check_tag02')"><svg>
                <use xlink:href="/svg/sprite.svg#icon_pen" /></svg></button></p>
          </dd>
          <dt>顧客タグ</dt>
          <dd class="form_check">
            <ul class="form_check-tag">
              <template v-for="list in values.c_m_tag_pk">
                <li v-if="list.checked" :key="list.value">{{list.text}}</li>
              </template>
            </ul>
            <p class="form_check-btn"><button type="button" class="btn01 cl_wh" v-on:click="showModalU('check_tag03')"><svg>
                <use xlink:href="/svg/sprite.svg#icon_pen" /></svg></button></p>
          </dd>
          <dt>検索タグ</dt>
          <dd class="form_check">
            <ul class="form_check-tag">
              <template v-for="list in values.p_m_tag_pk">
                <li v-if="list.checked" :key="list.value">{{list.text}}</li>
              </template>
            </ul>
            <p class="form_check-btn"><button type="button" class="btn01 cl_wh" v-on:click="showModalU('check_tag04')"><svg>
                <use xlink:href="/svg/sprite.svg#icon_pen" /></svg></button></p>
          </dd>
          <dt>企画の説明</dt>
          <dd>
            <textarea id="description" v-model="values.description" :class="{'error':errors.description}" class="text-type03 h_l"></textarea>
            <span class="error__text" v-show="errors.description">未入力です</span>
          </dd>
          <dt>TOP用ビジュアル＋イメージ画像</dt>
          <dd class="form_file">
            <vueDropzone id="dropzone_image" ref="myVueDropzoneImage" :class="{'error':errors.dropzone_image}" :options="dropzoneImageOptions" :duplicateCheck="true" v-on:vdropzone-file-added="uploadStart(1)" v-on:vdropzone-queue-complete="setMyVueDropzone" v-on:vdropzone-removed-file="uploadStart(1);setMyVueDropzone"></vueDropzone>
            <span class="error__text" v-show="errors.dropzone_image">未登録です</span>
            <p class="notetext">※1枚目＝TOP画面で使用<br>
            ※2枚目以降＝スライド用：資料の中身がわかるようなイメージ画像<br>
            ※PDFは1ページのみjpgに変換します
            
            </p>
          </dd>
          <dt>添付ファイル：企画書・仕様書・POP・報告書等</dt>
          <dd class="form_file">
            <vueDropzone id="dropzone" ref="myVueDropzone" :options="dropzoneOptions" :duplicateCheck="true" v-on:vdropzone-file-added="uploadStart(1)" v-on:vdropzone-queue-complete="setMyVueDropzone" v-on:vdropzone-removed-file="uploadStart(1);setMyVueDropzone"></vueDropzone>
          </dd>
          <template v-if="uploadedFile.length">
          <dt>アップ済み画像・ファイル</dt>
          <dd class="form_file">
              <ul class="file-list">
                <li v-for="(list, index) in uploadedFile" :key="list.pk">
                  <div class="file-l">
                    <input type="checkbox" :value="index" :id="'file01-' + list.key" :checked="list.checked" class="check_type02 del_file">
                    <label :for="'file01-' + list.key" class="label_type02"><i class="fas" :class="fileIcon(list.ext,list.thumbnail)"></i>{{list.name}}.{{list.ext}}</label>
                  </div>
                  <div class="file-r">
                    <span class="file-capacity">{{list.size}}</span>
                    <p class="file-delete"><button type="button" v-on:click="fileDelete('btn',index)" class="btn02 cl_pp"><svg>
                        <use xlink:href="/svg/sprite.svg#icon_trash" /></svg></button></p>
                  </div>
                </li>
              </ul>
              <p class="file-btn"><button type="button" class="btn01 cl_gr" v-on:click="fileDelete('check')">チェックしたファイルを削除</button></p>
          </dd>
          </template>
        </dl>
        <div class="btnbox"><a href="/" class="linebtn_bold arrow_l">一覧へ戻る</a><button type="button" v-on:click="setSubmit()" class="btn01 cl_pp">登録する</button></div>
      </div>
      <modal class="check_member" name="check_tag01" :width="580" :height="615">
        <button v-on:click="hideModal('check_tag01')" class="close"></button>
        <div class="modal">
          <div class="modal_box">
            <h3 class="page_title">関係者設定</h3>
            <p class="modal_search-word">
              <svg><use xlink:href="/svg/sprite.svg#icon_search" /></svg>
              <input
                type="text"
                v-model="k_tag_1"
                @keyup="tagNarrowOne(k_tag_1,'pe')"
                @blur="tagNarrowOne(k_tag_1,'pe')"
                class="text-type01 cl_gr"
                placeholder="キーワードを入力してください"
              />
            </p>
            <ul class="modal_search-check-list type02">
              <li v-for="(list,index) in values.pe_m_tag_pk" :key="list.text">
                <input type="checkbox" :id="'tag01_' + list.value" :checked="list.checked" class="check_type04 pe_m_tag_check">
                <label :for="'tag01_' + list.value" class="label_type04">{{list.text}}</label>
                <button type="button" class="btn_delete" v-on:click="delTag('pe_m_tag_pk',list.value,index)" v-if="values.tag_edit_flg">×</button>
              </li>
            </ul>
            <div class="modal_plus-word">
              <input type="text" name="pe_m_tag_name" class="text-type01 cl_gr" placeholder="関係者名を入力してください">
              <button type="button" class="btn01 cl_pp" v-on:click="addTag(1)">追加</button>
              <span class="error__text" v-show="errors.add_name">未入力です</span>
              <span class="error__text" v-show="errors.add_same">同じタグ名があります</span>
            </div>
            <div class="modal_btnbox">
              <button type="button" class="linebtn" v-on:click="checkAllClear('pe_m_tag_check')">クリア</button>
              <button type="button" v-on:click="setTagCheked('pe','tag01')" class="btn01 cl_pp">設定する</button>
            </div>
          </div>
        </div>
      </modal>
      <modal class="check_tag" name="check_tag02" :width="580" :height="615">
        <button v-on:click="hideModal('check_tag02')" class="close"></button>
        <div class="modal">
          <div class="modal_box">
            <h3 class="page_title">事業タグ設定</h3>
            <p class="modal_search-word">
              <svg><use xlink:href="/svg/sprite.svg#icon_search" /></svg>
              <input
                type="text"
                v-model="k_tag_2"
                @keyup="tagNarrowOne(k_tag_2,'b')"
                @blur="tagNarrowOne(k_tag_2,'b')"
                class="text-type01 cl_gr"
                placeholder="キーワードを入力してください"
              />
            </p>
            <ul class="modal_search-check-list">
              <li v-for="(list,index) in values.b_m_tag_pk" :key="list.text">
                <input type="checkbox" :id="'tag02_' + list.value" :checked="list.checked" class="check_type01 b_m_tag_check">
                <label :for="'tag02_' + list.value" class="label_type01 cl_pp">{{list.text}}</label>
                <button type="button" class="btn_delete" v-on:click="delTag('b_m_tag_pk',list.value,index)" v-if="values.tag_edit_flg">×</button>
              </li>
            </ul>
            <div class="modal_plus-word">
              <input type="text" name="b_m_tag_name" class="text-type01 cl_gr" placeholder="タグ名を入力してください">
              <button type="button" class="btn01 cl_pp" v-on:click="addTag(3)">追加</button>
              <span class="error__text" v-show="errors.add_name">未入力です</span>
              <span class="error__text" v-show="errors.add_same">同じタグ名があります</span>
            </div>
            <div class="modal_btnbox">
              <button type="button" class="linebtn cl_lb" v-on:click="checkAllClear('b_m_tag_check')">クリア</button>
              <button type="button" v-on:click="setTagCheked('b','tag02')" class="btn01 cl_pp">設定する</button>
            </div>
          </div>
        </div>
      </modal>
      <modal class="check_tag" name="check_tag03" :width="580" :height="615">
        <button v-on:click="hideModal('check_tag03')" class="close"></button>
        <div class="modal">
          <div class="modal_box">
            <h3 class="page_title">主要顧客タグ設定</h3>
            <p class="modal_search-word">
              <svg><use xlink:href="/svg/sprite.svg#icon_search" /></svg>
              <input
                type="text"
                v-model="k_tag_3"
                @keyup="tagNarrowOne(k_tag_3,'c')"
                @blur="tagNarrowOne(k_tag_3,'c')"
                class="text-type01 cl_gr"
                placeholder="キーワードを入力してください"
              />
            </p>
            <ul class="modal_search-check-list">
              <li v-for="(list,index) in values.c_m_tag_pk" :key="list.text">
                <input type="checkbox" :id="'tag03_' + list.value" :checked="list.checked" class="check_type01 c_m_tag_check">
                <label :for="'tag03_' + list.value" class="label_type01 cl_pp">{{list.text}}</label>
                <button type="button" class="btn_delete" v-on:click="delTag('c_m_tag_pk',list.value,index)" v-if="values.tag_edit_flg">×</button>
              </li>
            </ul>
            <div class="modal_plus-word">
              <input type="text" name="c_m_tag_name" class="text-type01 cl_gr" placeholder="タグ名を入力してください">
              <button type="button" class="btn01 cl_pp" v-on:click="addTag(4)">追加</button>
              <span class="error__text" v-show="errors.add_name">未入力です</span>
              <span class="error__text" v-show="errors.add_same">同じタグ名があります</span>
            </div>
            <div class="modal_btnbox">
              <button type="button" class="linebtn cl_lb" v-on:click="checkAllClear('c_m_tag_check')">クリア</button>
              <button type="button" v-on:click="setTagCheked('c','tag03')" class="btn01 cl_pp">設定する</button>
            </div>
          </div>
        </div>
      </modal>
      <modal class="check_tag" name="check_tag04" :width="580" :height="615">
        <button v-on:click="hideModal('check_tag04')" class="close"></button>
        <div class="modal">
          <div class="modal_box">
            <h3 class="page_title">検索タグ設定</h3>
            <p class="modal_search-word">
              <svg><use xlink:href="/svg/sprite.svg#icon_search" /></svg>
              <input
                type="text"
                v-model="k_tag_4"
                @keyup="tagNarrowOne(k_tag_4,'p')"
                @blur="tagNarrowOne(k_tag_4,'p')"
                class="text-type01 cl_gr"
                placeholder="キーワードを入力してください"
              />
            </p>
            <ul class="modal_search-check-list">
              <li v-for="(list,index) in values.p_m_tag_pk" :key="list.text">
                <input type="checkbox" :id="'tag04_' + list.value" :checked="list.checked" class="check_type01 p_m_tag_check">
                <label :for="'tag04_' + list.value" class="label_type01 cl_pp">{{list.text}}</label>
                <button type="button" class="btn_delete" v-on:click="delTag('p_m_tag_pk',list.value,index)" v-if="values.tag_edit_flg">×</button>
              </li>
            </ul>
            <div class="modal_plus-word">
              <input type="text" name="p_m_tag_name" class="text-type01 cl_gr" placeholder="タグ名を入力してください">
              <button type="button" class="btn01 cl_pp" v-on:click="addTag(2)">追加</button>
              <span class="error__text" v-show="errors.add_name">未入力です</span>
              <span class="error__text" v-show="errors.add_same">同じタグ名があります</span>
            </div>
            <div class="modal_btnbox">
              <button type="button" class="linebtn cl_lb" v-on:click="checkAllClear('p_m_tag_check')">クリア</button>
              <button type="button" v-on:click="setTagCheked('p','tag04')" class="btn01 cl_pp">設定する</button>
            </div>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>
<script>
  import {
    Mixin
  } from '../mixin'
  export default {
    name: 'upload',
    mixins: [Mixin],
    data() {
      return {
        dropzoneImageOptions: {
          url: this.UploadURI,
          method: 'post',
          maxFilesize: 1000,
          timeout: 600000, //ms
          parallelUploads: 10,
          addRemoveLinks: true,
          acceptedFiles: "image/gif,image/jpg,image/jpeg,image/png,application/pdf",
          headers: {
            'Cache-Control': "no-cache",
            'X-Requested-With': null
          },
        },
        dropzoneOptions: {
          url: this.UploadURI,
          method: 'post',
          maxFilesize: 1000,
          timeout: 600000, //ms
          parallelUploads: 10,
          addRemoveLinks: true,
          headers: {
            'Cache-Control': "no-cache",
            'X-Requested-With': null
          },
        },
        k_tag_1: '',
        k_tag_2: '',
        k_tag_3: '',
        k_tag_4: '',
        all_tags: {
          pe_m_tag_pk: [],
          b_m_tag_pk: [],
          p_m_tag_pk: [],
          c_m_tag_pk: []
        },
        values: {
          pe_m_tag_pk: [],
          b_m_tag_pk: [],
          p_m_tag_pk: [],
          c_m_tag_pk: []
        }, // 情報セット
        connect_flg: false, // 通信フラグ
        uploadFlg: false, // アップロード中フラグ
        uploadFile: {}, // 一時アップロード
        uploadedFile: [], // 削除ファイル
        errors: {}, // エラー
      }
    },
    async created() {
      //Loading Start
      var loader = this.loadingShow()
      let params = new URLSearchParams()
      params.append('c', 'upload-1')
      params.append('lo_pk', this.$cookies.get('lo_pk'))
      params.append('lo_sid', this.$cookies.get('lo_sid'))
      params.append('pk', this.$route.params.pk)
      await this.axios.post(this.RequestURI, params, {
        headers: {
          "Cache-Control": "no-cache"
        }
      }).then((response) => {
        if (response.data.status == 'success') { // 成功

          //権限チェック
          console.log(response.data.values)
          if (response.data.values.level == 0){
            alert('権限がありません')
            location.href = '/'
          }

          this.values = response.data.values
          //タブ絞り込みように元データ保存
          for (var key in this.all_tags) {
            this.all_tags[key] = this.values[key]
          }
          //更新日
          if (this.values.entdt) {
            const entdt = this.values.entdt.split(" ")
            this.values.entdt = entdt[0]
          } else {
            this.values.entdt = this.YYMMDD()
          }
          this.uploadedFile = response.data.uploadedFile
        } else { // ログインに戻す
          this.removeLogin()
        }
      }).catch(() => {
        this.removeLogin()
      })
      // Loading Finish
      loader.hide()
      window.addEventListener("beforeunload", this.confirmOut);
    },
    destroyed() {
      window.removeEventListener("beforeunload", this.confirmOut);
    },
    methods: {
      // upload情報セット
      setMyVueDropzone() {
        var refArr = ['myVueDropzoneImage', 'myVueDropzone']
        // 初期化
        this.uploadFile = {}
        var cnt = 1
        for (const ref of refArr) {
          var files = this.$refs[ref].getAcceptedFiles()
          for (var i = 0; files.length > i; i++) {
            var file = files[i]
            var obj = JSON.parse(file.xhr.response)
            this.$set(this.uploadFile, cnt, {
              key: obj.key,
              area: ref,
              name: obj.name
            })
            cnt++
          }
        }
        // upload終了
        this.uploadFlg = false
      },
      // upload開始
      uploadStart() {
        this.uploadFlg = true
      },
      // 登録処理
      setSubmit() {
        this.errors = {} // 初期化
        if (!this.values.entdt) this.$set(this.errors, 'entdt', true) // 日付
        if (!this.values.name) this.$set(this.errors, 'name', true) // 案件名
        if (!this.values.client_name) this.$set(this.errors, 'client_name', true) // 顧客名
        if (!this.values.description) this.$set(this.errors, 'description', true) // 規格説明
        // 画像チェック
        var files = this.$refs.myVueDropzoneImage.getAcceptedFiles()
        if (!files.length && !this.$route.params.pk) this.$set(this.errors, 'dropzone_image', true)
      
        // エラーがなければサブミット
        if (Object.keys(this.errors).length == 0 && this.uploadFlg == false && !this.connect_flg) {
          // 通信開始
          this.connect_flg = true
          let params = new URLSearchParams()
          params.append('c', 'upload-2')
          params.append('lo_pk', this.$cookies.get('lo_pk'))
          params.append('lo_sid', this.$cookies.get('lo_sid'))
          params.append('uploadFile', JSON.stringify(this.uploadFile))
          const tags = ['pe_m_tag_pk', 'b_m_tag_pk', 'p_m_tag_pk', 'c_m_tag_pk']
          for (let key in this.values) { // this.valuesをparams格納
            if (tags.indexOf(key) == -1) {
              params.append(key, this.values[key])
            }
          }
          for (var tag of tags) {
            var tag_pks = []
            var arr = this.values[tag]
            for (var i = 0; arr.length > i; i++) {
              if (arr[i].checked == true) {
                tag_pks.push(arr[i].value)
              }
            }
            params.append(tag, tag_pks)
          }
          this.axios.post(this.RequestURI, params, {
            headers: {
              "Cache-Control": "no-cache"
            }
          }).then((response) => {
            if (response.data.status == 'success') { // 成功
              this.$confirm({
                message: '登録が完了しました',
                button: {
                  yes: 'OK'
                },
                /**
                 * Callback Function
                 * @param {Boolean} confirm 
                 */
                callback: confirm => {
                  if (confirm) {
                    this.$router.push('/')
                  }
                }
              })
            } else if (response.data.status == 'inputError') { // 入力エラー
              // エラーセット
              this.errors = response.data.errors
              // エラー位置にスクロール
              this.errorScrollBack()
            } else { // ログインに戻す
              this.removeLogin()
            }
          }).catch(() => {
            this.removeLogin()
          })
        } else {
          // エラー位置にスクロール
          this.errorScrollBack()
        }
        // 通信終了
        this.connect_flg = false
      },
      myScroll(id, point) {
        var myMain = document.getElementById(id)
        var rect = myMain.getBoundingClientRect()
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop
        var myTop = rect.top + scrollTop + point
        scrollTo(0, myTop)
      },
      errorScrollBack() {
        if (this.errors.entdt == true) {
          this.myScroll('entdt', -100)
        } else if (this.errors.name == true) {
          this.myScroll('name', -100)
        } else if (this.errors.client_name == true) {
          this.myScroll('client_name', -100)
        } else if (this.errors.description == true) {
          this.myScroll('description', -100)
        } else if (this.errors.dropzone_image == true) {
          this.myScroll('dropzone_image', -100)
        }
      },
      setTagCheked(t, idn) { // タグセット
        var tag_check = t + '_m_tag_check'
        var tag_pk = t + '_m_tag_pk'
        var arr = document.getElementsByClassName(tag_check)
        for (var i = 0; arr.length > i; i++) {
          this.$set(eval('this.values.' + tag_pk + '[i]'), 'checked', arr[i].checked)
        }
        this.hideModal('check_' + idn)
      },
      addTag(kind) { // タグ追加
        this.$set(this.errors, 'add_name', false)
        this.$set(this.errors, 'add_kind', false)
        this.$set(this.errors, 'add_same', false)
        var tag
        if (kind == 1) {
          tag = 'pe_m_tag'
        } else if (kind == 2) {
          tag = 'p_m_tag'
        } else if (kind == 3) {
          tag = 'b_m_tag'
        } else if (kind == 4) {
          tag = 'c_m_tag'
        }
        var add_name = document.getElementsByName(tag + '_name')[0].value
        if (!add_name) { // タグ名がなければ戻す
          this.$set(this.errors, 'add_name', true)
          return
        }
        if (!this.connect_flg) {
          // 通信開始
          this.connect_flg = true
          let params = new URLSearchParams()
          params.append('c', 'upload-add_tag')
          params.append('lo_pk', this.$cookies.get('lo_pk'))
          params.append('lo_sid', this.$cookies.get('lo_sid'))
          params.append('kind', kind)
          params.append('name', add_name)
          this.axios.post(this.RequestURI, params, {
            headers: {
              "Cache-Control": "no-cache"
            }
          }).then((response) => {
            if (response.data.status == 'success') { // 成功
              this.values[tag + '_pk'].push(response.data.values)
              // 初期化
              document.getElementsByName(tag + '_name')[0].value = ''
            } else if (response.data.status == 'inputError') {
              this.errors = response.data.errors
              // 初期化
              document.getElementsByName(tag + '_name')[0].value = ''
            } else { // ログインに戻す
              this.removeLogin()
            }
          }).catch(() => {
            this.removeLogin()
          })
          // 通信終了
          this.connect_flg = false
        }
      },
      delTag(tag, pk, index) { // タグ削除
        if (window.confirm('タグを無効にしますか？')) {
          if (!this.connect_flg) {
            // 通信開始
            this.connect_flg = true
            let params = new URLSearchParams()
            params.append('c', 'upload-del_tag')
            params.append('lo_pk', this.$cookies.get('lo_pk'))
            params.append('lo_sid', this.$cookies.get('lo_sid'))
            params.append('pk', pk)
            this.axios.post(this.RequestURI, params, {
              headers: {
                "Cache-Control": "no-cache"
              }
            }).then((response) => {
              if (response.data.status == 'success') { // 成功
                this.values[tag].splice(index, 1)
              } else { // ログインに戻す
                this.removeLogin()
              }
            }).catch(() => {
              this.removeLogin()
            })
            // 通信終了
            this.connect_flg = false
          }
        } else {
          return false;
        }
      },
      checkAllClear(name) { // 全てのチェックを外す
        var el = document.getElementsByClassName(name)
        for (let i = 0; el.length > i; i++) {
          el[i].checked = false;
        }
      },
      showModalU(name) {
        // 初期値リセット
        this.$set(this.errors, 'add_name', false)
        this.$set(this.errors, 'add_kind', false)
        this.$set(this.errors, 'add_same', false)
        this.showModal(name)
      },
      fileDelete(flg, index) { // ファイル削除
        var delArray = []
        if (flg == 'check') {
          var el = document.getElementsByClassName('del_file')
          for (var i = 0; el.length > i; i++) {
            if (el[i].checked == true) {
              delArray.push(this.uploadedFile[i].key)
            }
          }
        } else if (flg == 'btn') {
          delArray.push(this.uploadedFile[index].key)
        }
        if (!delArray.length) {
          alert('ファイルが選択されていません');
          return
        }
        if (!this.connect_flg) {
          // 通信開始
          this.connect_flg = true
          let params = new URLSearchParams()
          params.append('c', 'upload-del_file')
          params.append('lo_pk', this.$cookies.get('lo_pk'))
          params.append('lo_sid', this.$cookies.get('lo_sid'))
          params.append('pk', this.$route.params.pk)
          params.append('del_key', delArray)
          this.axios.post(this.RequestURI, params, {
            headers: {
              "Cache-Control": "no-cache"
            }
          }).then((response) => {
            if (response.data.status == 'success') { // 成功
              if (flg == 'check') {
                var el = document.getElementsByClassName('del_file')
                for (var i = el.length - 1; i >= 0; i--) {
                  if (el[i].checked == true) {
                    this.uploadedFile.splice(i, 1)
                  }
                }
              } else if (flg == 'btn') {
                this.uploadedFile.splice(index, 1)
              }
            } else { // ログインに戻す
              this.removeLogin()
            }
          }).catch(() => {
            this.removeLogin()
          })
          // 通信終了
          this.connect_flg = false
        }
      },
      tagNarrowOne: function(k, t) {
        var tag_check = t + '_m_tag_check'
        var tag_pk = t + '_m_tag_pk'
        //チェック取得
        var arr = document.getElementsByClassName(tag_check)
        var checked = []
        for (var i = 0; arr.length > i; i++) {
          if (arr[i].checked) {
            //idからpk取得(tag01_1)
            const str_pk = arr[i].id.split("_")
            checked.push(str_pk[1])
          }
        }
        this.values[tag_pk] = this.all_tags[tag_pk].filter(function(item) {
          return (item.text.indexOf(k) > -1 || checked.indexOf(item.value) > -1);
        })
      },
      confirmOut(event) {
        event.returnValue = ''
      }
    }
  }

</script>